





























import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  SetupContext
} from "@vue/composition-api";

type Props = {
  display: string;
};

export default createComponent({
  props: {
    display: {
      type: String,
      require: true
    }
  },
  setup(props: Props, context: SetupContext) {
    const displayType = props.display;

    const supportCenter = {
      name: "株式会社ＪＯＢＰＡＹ　 サポートセンター",
      address: "東京都渋谷区渋谷2-12-19　東建インターナショナルビル8F",
      mailText: "E-mail : support@jobpay.co.jp",
      faxText: "FAX: 050-3730-8542",
      telText: "TEL: 050-3786-0909",
      timeText: "電話受付時間：午前９時～午後６時（祝日を除く月曜日から金曜日）"
    };

    return {
      supportCenter,
      displayType
    };
  }
});
